import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { EmissorContractStatus } from '../types/contractStatus';
import { useContractStatusTracking } from './useContractStatusTracking';
export function useEmissorFlow() {
    const { isFeatureFlagWhiteListed } = useFeatureFlag(undefined, { isLoggedIn: true });
    const isEmissorEnabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_EMISSOR_ENABLED);
    const appDomain = useAppSelector(selectAppDomain);
    const { contract, status, isLoading } = useContractStatusTracking({
        appDomain,
        skip: !isEmissorEnabled,
        redirectOnActive: false,
    });
    const isEmissorFlow = isEmissorEnabled && status === EmissorContractStatus.ACTIVATED;
    return {
        isEmissorFlow,
        emissorContractId: isEmissorFlow ? (contract?.id ?? null) : null,
        emissorContractLegalName: isEmissorFlow ? (contract?.legalName ?? null) : null,
        isLoading,
    };
}
